import { render } from "./LinksPage.vue?vue&type=template&id=7411b2ad"
import script from "./LinksPage.vue?vue&type=script&lang=js"
export * from "./LinksPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__